/* ============================================================================
   REPORTES ESPECIALES — Portal Kennedy
   ---------------------------------------------------------------------------
   Dos formatos que se generan a partir de una factura o un pedido ya cargado
   en la pantalla de Reportes:

     1) FACTURA FORMATO AID
        Copia del Excel que se le manda a A.I.D.: cabecera con SOLD TO /
        INVOICE / SALES PERSON / DATE / PAYMENTS TERMS, una linea por
        articulo con CTN, WEIGHT, CUB FT, REFERENCE, DESCRIPTION, QTY, UNI,
        PRICE, TOTAL, BARCODE, BRAND, COMPOSITION, ORIGEN, PIC y COLOR, y al
        pie T.CTN, SUBTOTAL, TRANSPORT, DOCS y TOTAL.

     2) FICHA TECNICA DE ALFOMBRAS
        Las 18 columnas del reporte de SAP (composicion de pelo y de respaldo,
        tecnica, intensidad de uso, espesores, gramaje...) con la foto de cada
        articulo incrustada.

   De donde salen los datos:
     - `rptDoc` y `rptLineas`, que ya deja cargados rptCargar()
     - `unitmsr` y `linetotal` se piden aparte: rptFetch no los trae
     - las caracteristicas del articulo (composicion, color, origen y todos
       los campos de alfombra) salen de `vista_inventario.caracteristicas`
     - la condicion de pago y el pais, de `clientes`

   Se apoya en lo que ya existe: _ensureExcelJS, _fetchImgPool y fotoPair.

   Prefijo `r2`.
============================================================================ */

// ── Utilidades ──────────────────────────────────────────────────────────────
function r2Esc(s){
  return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
function r2Num(v){ var n=Number(v); return isFinite(n)?n:0; }

// Normaliza una clave para comparar: minusculas, sin acentos y sin nada que
// no sea letra o numero. Asi "Espesor De Pelo", "ESPESOR_PELO" y "EspesorPelo"
// se convierten todas en algo comparable.
function r2Norm(s){
  s=String(s||'').toLowerCase();
  try{ s=s.normalize('NFD').replace(/[\u0300-\u036f]/g,''); }catch(e){}
  return s.replace(/[^a-z0-9]/g,'');
}

// Busca un valor dentro de `caracteristicas`.
//
// OJO CON LAS CLAVES: el sync (kennedy_live.py, funcion `etiqueta`) usa el
// NOMBRE de la columna del campo de usuario en SAP, no la descripcion que se
// ve en el Item Master Data. O sea que el campo que en pantalla dice
// "ESPESOR DE PELO" puede llegar aqui como "Espesor Pelo" o "Esppelo" segun
// como se llamara la columna. Por eso no se comparan textos enteros: cada
// patron es una lista de PALABRAS que tienen que aparecer todas en la clave,
// y los patrones se prueban del mas especifico al mas general.
function r2Car(c, grupos, evitar){
  if(!c || typeof c!=='object') return '';
  var keys=Object.keys(c);
  var norm=keys.map(r2Norm);
  var ev=(evitar||[]).map(r2Norm);
  for(var g=0; g<grupos.length; g++){
    var toks=grupos[g].map(r2Norm);
    for(var i=0;i<keys.length;i++){
      var k=norm[i];
      if(ev.length && ev.some(function(e){ return k.indexOf(e)>=0; })) continue;
      var todas=toks.every(function(t){ return k.indexOf(t)>=0; });
      if(!todas) continue;
      var v=c[keys[i]];
      if(v!=null && String(v).trim()!=='') return String(v).trim();
    }
  }
  return '';
}

// "50X120 CM" -> "50X120". El campo Tamano trae el sufijo; el reporte de SAP
// muestra la medida sola.
function r2Quitacm(v){
  return String(v||'').replace(/\s*(cms?|centimetros?)\s*$/i,'').trim();
}

// El logo ya vive en el liquid como PNG en base64 (la barra lateral y la
// pantalla de acceso). Se toma de ahi en vez de subir otro asset.
function r2Logo(){
  var sels=['.sb-logo img','img.alogo','#auth .alogo','.sb-logo image'];
  for(var i=0;i<sels.length;i++){
    var im=document.querySelector(sels[i]);
    var src=im && (im.src||im.getAttribute('src'));
    if(src && src.indexOf('data:image/')===0){
      var coma=src.indexOf(','); if(coma<0) continue;
      var tipo=/data:image\/([a-z]+)/i.exec(src);
      return {b64:src.slice(coma+1), ext:(tipo?tipo[1].toLowerCase():'png')};
    }
  }
  return null;
}

// ── Paises ────────────────────────────────────────────────────────────────
// SAP guarda el codigo de dos letras. En el reporte tiene que salir el nombre.
var R2_PAISES={
  CN:['CHINA','CHINA'],               TW:['TAIWAN','TAIWAN'],
  IN:['INDIA','INDIA'],               VN:['VIETNAM','VIETNAM'],
  TH:['TAILANDIA','THAILAND'],        ID:['INDONESIA','INDONESIA'],
  MY:['MALASIA','MALAYSIA'],          BD:['BANGLADESH','BANGLADESH'],
  PK:['PAKISTAN','PAKISTAN'],         TR:['TURQUIA','TURKEY'],
  EG:['EGIPTO','EGYPT'],              BE:['BELGICA','BELGIUM'],
  NL:['HOLANDA','NETHERLANDS'],       DE:['ALEMANIA','GERMANY'],
  ES:['ESPANA','SPAIN'],              IT:['ITALIA','ITALY'],
  FR:['FRANCIA','FRANCE'],            PT:['PORTUGAL','PORTUGAL'],
  GB:['REINO UNIDO','UNITED KINGDOM'],UK:['REINO UNIDO','UNITED KINGDOM'],
  US:['ESTADOS UNIDOS','UNITED STATES'], CA:['CANADA','CANADA'],
  MX:['MEXICO','MEXICO'],             BR:['BRASIL','BRAZIL'],
  CO:['COLOMBIA','COLOMBIA'],         PE:['PERU','PERU'],
  CL:['CHILE','CHILE'],               AR:['ARGENTINA','ARGENTINA'],
  PA:['PANAMA','PANAMA'],             CR:['COSTA RICA','COSTA RICA'],
  GT:['GUATEMALA','GUATEMALA'],       DO:['REP. DOMINICANA','DOMINICAN REP.'],
  KR:['COREA DEL SUR','SOUTH KOREA'], JP:['JAPON','JAPAN'],
  IL:['ISRAEL','ISRAEL'],             AE:['EMIRATOS ARABES','UNITED ARAB EMIRATES'],
  PL:['POLONIA','POLAND'],            GR:['GRECIA','GREECE'],
  RO:['RUMANIA','ROMANIA'],           CZ:['REP. CHECA','CZECH REP.'],
  AU:['AUSTRALIA','AUSTRALIA'],       NZ:['NUEVA ZELANDA','NEW ZEALAND'],
  ZA:['SUDAFRICA','SOUTH AFRICA'],    MA:['MARRUECOS','MOROCCO'],
  PH:['FILIPINAS','PHILIPPINES'],     LK:['SRI LANKA','SRI LANKA'],
  NP:['NEPAL','NEPAL'],               IR:['IRAN','IRAN']
};

// Solo se traduce si lo que viene ES un codigo de dos letras: si el campo ya
// trae "EGIPTO" se respeta tal cual.
function r2Pais(v, idioma){
  var t=String(v||'').trim();
  if(!t) return '';
  if(!/^[A-Za-z]{2}$/.test(t)) return t.toUpperCase();
  var p=R2_PAISES[t.toUpperCase()];
  if(!p) return t.toUpperCase();
  return (idioma==='en') ? p[1] : p[0];
}

function r2Fecha(d){
  var s=String(d||'').slice(0,10).split('-');
  if(s.length===3) return (+s[2])+'/'+(+s[1])+'/'+s[0];
  return String(d||'');
}
function r2FechaHora(){
  var d=new Date(), p=function(n){ return (n<10?'0':'')+n; };
  var h=d.getHours(), am=h<12?'am':'pm'; h=h%12; if(!h) h=12;
  return p(d.getDate())+'/'+p(d.getMonth()+1)+'/'+d.getFullYear()
    +'  '+h+':'+p(d.getMinutes())+' '+am;
}

function r2Listo(){
  if(typeof rptDoc==='undefined' || !rptDoc || !rptLineas || !rptLineas.length){
    alert('Primero carga una factura o un pedido arriba.');
    return false;
  }
  return true;
}


/* ══════════════════════════════════════════════════════════════════════════
   DATOS
   ══════════════════════════════════════════════════════════════════════════ */

var R2_CACHE={};   // docnum -> datos ya enriquecidos

// Completa las lineas con lo que rptFetch no trae: la unidad de medida y el
// total de linea (que lleva el descuento aplicado) del documento, y las
// caracteristicas del articulo.
async function r2Datos(){
  var num=String((rptDoc&&rptDoc.docnum)||'');
  var clave=rptTipo+'-'+num;
  if(R2_CACHE[clave]) return R2_CACHE[clave];

  var tabla=(rptTipo==='factura')?'facturas':'pedidos';
  var porLinea={};
  if(num){
    try{
      var ls=await q(tabla,'select=linenum,itemcode,quantity,unitmsr,linetotal,price'
        +'&docnum=eq.'+encodeURIComponent(num)+'&order=linenum&limit=900');
      (ls||[]).forEach(function(l){ if(l.itemcode && !porLinea[l.itemcode]) porLinea[l.itemcode]=l; });
    }catch(e){}
  }

  var carac={};
  var codes=rptLineas.map(function(l){ return l.itemcode; }).filter(Boolean);
  if(codes.length){
    try{
      var en=Array.from(new Set(codes))
        .map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      var inv=await q('vista_inventario',
        'select=itemcode,caracteristicas,codebars,marca,peso,volumen,unidadesbulto'
        +'&itemcode=in.('+en+')&limit='+codes.length);
      (inv||[]).forEach(function(r){ carac[r.itemcode]=r; });
    }catch(e){}
  }

  var cli={};
  if(rptDoc.cardcode){
    try{
      var c=await q('clientes','select=cardcode,cardname,country,condicionpago,nombrevendedor'
        +'&cardcode=eq.'+encodeURIComponent(rptDoc.cardcode)+'&limit=1');
      cli=(c&&c[0])||{};
    }catch(e){}
  }

  var lineas=rptLineas.map(function(l){
    var d=porLinea[l.itemcode]||{};
    var v=carac[l.itemcode]||{};
    var cc=v.caracteristicas;
    var qty=r2Num(l.quantity)||r2Num(d.quantity);
    var precio=r2Num(l.price)||r2Num(d.price);
    var pack=r2Num(l.packing)||r2Num(v.unidadesbulto);

    return {
      itemcode: l.itemcode,
      // La descripcion del formato AID va en ingles.
      desc_en: l.frgnname || l.dscription || '',
      desc_es: l.dscription || l.frgnname || '',
      qty: qty,
      unidad: (d.unitmsr||'').toUpperCase() || 'PZA',
      precio: precio,
      total: (d.linetotal!=null ? r2Num(d.linetotal) : qty*precio),
      packing: pack,
      // Cajas: lo que ocupan las piezas al ritmo de piezas por bulto. Se
      // redondea hacia arriba porque una caja a medias sigue siendo una caja.
      ctn: (pack>0 ? Math.ceil(qty/pack) : 0),
      peso: r2Num(l.peso)||r2Num(v.peso),
      volumen: r2Num(l.volumen)||r2Num(v.volumen),
      barcode: l.barcode || v.codebars || '',
      marca: l.marca || v.marca || '',
      // La composicion general (formato AID): la de SAP viene como
      // "PELO: 100% COCO  RESP: 100% VINIL". Se evitan las especificas de
      // alfombra para no coger solo una mitad.
      composicion: l.composicion
        || r2Car(cc,[['composicion']],['pelo','respaldo','ingles'])
        || r2Car(cc,[['compo']],['pelo','respaldo','ingles','2'])
        || r2Car(cc,[['material'],['fibra'],['content']]),
      color: l.color || r2Car(cc,[['color'],['colour'],['tono']],['acabado']),
      origen: r2Car(cc,[['origen'],['procedencia'],['pais'],['country'],['madein']]),
      foto_url: l.foto_url || '',
      foto_cands: l.foto_cands || (l.foto_url?[l.foto_url]:[]),
      _carac: cc || {},
      // Campos de la ficha de alfombras
      alf: {
        // Los nombres reales de los campos en este SAP (comprobados con
        // r2Claves) son cortos y no siempre dicen lo que representan:
        //   Pelo      -> COMPOSICION DE PELO
        //   Respaldo  -> COMPOSICION DE RESPALDO
        //   Uso       -> INTENSIDAD DE USO
        //   Espesor   -> ESPESOR DE PELO      Espesort -> ESPESOR TOTAL
        //   Pelopeso  -> PESO DE PELO         Porigen  -> ORIGEN
        //   Denominaciont -> DENOMINACION DEL TEJIDO
        //   Acabadocolor / Acabadosotros / Gramaje / Tamano
        // Los patrones largos se dejan primero por si en otra instalacion los
        // campos llevan el nombre completo.
        pelo:      r2Car(cc,[['composicion','pelo'],['comp','pelo'],['pile','composition'],
                             ['pelo']],
                            ['peso','espesor','densidad','acabado']),
        respaldo:  r2Car(cc,[['composicion','respaldo'],['comp','respaldo'],['respaldo'],['backing']]),
        tecnica:   r2Car(cc,[['tecnica','fabricacion'],['tecnica'],['fabricacion'],['manufact']]),
        uso:       r2Car(cc,[['intensidad','uso'],['intensidad'],['uso'],['trafico'],['traffic']]),
        // 'espesort' es el TOTAL: se excluye aqui para que no se lo lleve el
        // de pelo, que en esta base se llama simplemente 'Espesor'.
        espPelo:   r2Car(cc,[['espesor','pelo'],['altura','pelo'],['alto','pelo'],
                             ['pile','height'],['espesor']],
                            ['espesort','total']),
        espTotal:  r2Car(cc,[['espesor','total'],['espesort'],['altura','total'],
                             ['total','thickness']]),
        // 'espesordepelo' contiene la subcadena 'peso' (esPESOr), asi que sin
        // excluirlo el peso de pelo se llevaba el valor del espesor.
        pesoPelo:  r2Car(cc,[['peso','pelo'],['pelopeso'],['pile','weight']],['espesor']),
        // Aqui el campo es 'Tamano' y trae "50X120 CM". El reporte de SAP lo
        // muestra sin el sufijo, asi que se quita.
        medida:    r2Quitacm(r2Car(cc,[['dimensiones','cm'],['dimensiones'],['medida','cm'],
                                       ['medida'],['tamano'],['size']],['bulto','carton'])),
        tejido:    r2Car(cc,[['denominacion','tejido'],['denominacion'],['tejido'],['weave']]),
        acabadoCol:r2Car(cc,[['acabados','color'],['acabado','color']]),
        // "Otros acabados" no debe caer en "Acabados por color".
        otros:     r2Car(cc,[['otros','acabados'],['acabados','otros'],['otro','acabado']],['color']),
        gramaje:   r2Car(cc,[['gramaje'],['grm2']]),
        densidad:  r2Car(cc,[['densidad','pelo'],['densidad']]),
        puntos:    r2Car(cc,[['puntos']])
      }
    };
  });

  var datos={lineas:lineas, cliente:cli};
  R2_CACHE[clave]=datos;
  return datos;
}

// Descarga las fotos y las deja listas para incrustar. Se reutiliza el pool
// del portal, que ya las reduce de tamaño: sin eso un Excel de 200 lineas
// pesaba mas de lo que aguanta un correo.
async function r2Fotos(lineas, aviso){
  var cands=lineas.map(function(l){ return l.foto_cands&&l.foto_cands.length?l.foto_cands:null; });
  if(!cands.filter(Boolean).length) return {};
  try{
    return await _fetchImgPool(cands, aviso, 150, 0.72) || {};
  }catch(e){ return {}; }
}
function r2ImgDe(mapa, l){
  var c=l.foto_cands||[];
  for(var i=0;i<c.length;i++){ if(c[i] && mapa[c[i]] && mapa[c[i]].b64) return mapa[c[i]]; }
  return null;
}


/* ══════════════════════════════════════════════════════════════════════════
   DIAGNOSTICO DE CAMPOS
   ---------------------------------------------------------------------------
   Si una columna sale vacia no es un fallo del reporte: es que el campo no
   llego con ese nombre. Esto dice QUE nombres trae de verdad el articulo, que
   es lo unico que hace falta para ajustar los patrones de r2Car.
   ══════════════════════════════════════════════════════════════════════════ */

// Se escribe r2Claves() en la consola del navegador (F12) con una factura ya
// cargada, y lista las caracteristicas tal como llegan de SAP.
async function r2Claves(){
  if(!r2Listo()) return;
  var d=await r2Datos();
  console.log('%c CARACTERISTICAS QUE LLEGAN DE SAP ',
    'background:#0F766E;color:#fff;font-weight:700');
  d.lineas.forEach(function(l){
    var k=Object.keys(l._carac||{});
    console.log('\n' + l.itemcode + '  (' + k.length + ' campos)');
    if(!k.length){ console.log('   (sin caracteristicas)'); return; }
    console.table(k.map(function(x){ return {campo:x, valor:l._carac[x]}; }));
  });
  var todas={};
  d.lineas.forEach(function(l){ Object.keys(l._carac||{}).forEach(function(k){ todas[k]=1; }); });
  console.log('\nTodos los nombres distintos:', Object.keys(todas).sort().join(' | '));
  return Object.keys(todas).sort();
}

// Que columnas de la ficha quedaron vacias en TODAS las lineas.
function r2Vacias(lineas){
  var campos=[['COMPOSICION DE PELO','pelo'],['COMPOSICION DE RESPALDO','respaldo'],
    ['TECNICA DE FABRICACION','tecnica'],['INTENSIDAD DE USO','uso'],
    ['ESPESOR DE PELO','espPelo'],['ESPESOR TOTAL','espTotal'],['PESO DE PELO','pesoPelo'],
    ['MEDIDA EN CM','medida'],['DENOMINACION DEL TEJIDO','tejido'],
    ['ACABADOS POR COLOR','acabadoCol'],['OTROS ACABADOS','otros'],['GRAMAJE','gramaje']];
  return campos.filter(function(c){
    return lineas.every(function(l){ return !(l.alf&&l.alf[c[1]]); });
  }).map(function(c){ return c[0]; });
}


/* ══════════════════════════════════════════════════════════════════════════
   1) FACTURA FORMATO LIRAN
   ══════════════════════════════════════════════════════════════════════════ */

// Textos del reporte en los dos idiomas: [espanol, ingles].
var R2_T={
  soldto:['VENDIDO A','SOLD TO'],       invoice:['FACTURA','INVOICE'],
  order :['PEDIDO','ORDER'],            vend:['VENDEDOR','SALES PERSON'],
  fecha :['FECHA','DATE'],              terms:['CONDICION DE PAGO','PAYMENTS TERMS'],
  tctn  :['T.CAJAS','T.CTN'],           subtotal:['SUBTOTAL','SUBTOTAL'],
  total :['TOTAL','TOTAL'],
  cols  :[['CAJAS','PESO','PIE CUB','REFERENCIA','DESCRIPCION','CANT','UNI','PRECIO',
           'TOTAL','COD. BARRAS','MARCA','COMPOSICION','ORIGEN','FOTO','COLOR'],
          ['CTN','WEIGHT','CUB FT','REFERENCE','DESCRIPTION','QTY','UNI','PRICE',
           'TOTAL','BARCODE','BRAND','COMPOSITION','ORIGIN','PIC','COLOR']]
};
function r2t(k, idi){ var v=R2_T[k]; return v[idi==='en'?1:0]; }

// ── Gastos adicionales del documento ──────────────────────────────────────
// En SAP los gastos (flete, documentos, acarreo...) van en INV3 para las
// facturas y RDR3 para los pedidos, y su nombre en OEXD. NO se escriben a
// mano: vienen con el documento.
//
// Se buscan en dos pasos:
//   1) La tabla `gastos_documento`, que trae el desglose por concepto. Es la
//      que hay que sincronizar (ver PATCH-gastos-documento.md).
//   2) Si no esta, se deduce el total: DocTotal menos la suma de las lineas.
//      Sale un solo renglon, sin desglosar, pero el TOTAL cuadra igual.
var R2_GASTOS=[];

async function r2CargarGastos(sub){
  R2_GASTOS=[];
  var num=String((rptDoc&&rptDoc.docnum)||'');
  if(!num) return R2_GASTOS;

  try{
    var r=await q('gastos_documento',
      'select=nombre,codigo,monto,linenum&tipo=eq.'+encodeURIComponent(rptTipo)
      +'&docnum=eq.'+encodeURIComponent(num)+'&order=linenum');
    (r||[]).forEach(function(g){
      if(r2Num(g.monto)!==0){
        R2_GASTOS.push({n:(g.nombre||g.codigo||'GASTO'), v:r2Num(g.monto), origen:'sap'});
      }
    });
  }catch(e){}

  if(R2_GASTOS.length) return R2_GASTOS;

  // Sin desglose: la diferencia entre el total del documento y la suma de las
  // lineas son los gastos. Se ignoran las diferencias de centavos por redondeo.
  var tot=r2Num(rptDoc.doctotal);
  if(tot>0){
    var dif=Math.round((tot-sub)*100)/100;
    if(Math.abs(dif)>=0.01){
      R2_GASTOS.push({n:'GASTOS ADICIONALES', v:dif, origen:'diferencia'});
    }
  }
  return R2_GASTOS;
}

function r2GastosHTML(idi){
  if(!R2_GASTOS.length){
    return '<div style="font-size:12.5px;color:var(--text3,#888)">'
      +'Esta '+(rptTipo==='factura'?'factura':'orden')+' no trae gastos adicionales.</div>';
  }
  var h='<div style="border:1px solid var(--border,#e5e7eb);border-radius:8px;overflow:hidden">';
  R2_GASTOS.forEach(function(g,i){
    h+='<div style="display:flex;justify-content:space-between;gap:10px;padding:6px 10px;'
      +'font-size:12.5px'+(i?';border-top:1px solid var(--border,#eee)':'')+'">'
      +'<span>'+r2Esc(g.n)+'</span>'
      +'<b>'+r2Num(g.v).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})+'</b>'
      +'</div>';
  });
  h+='</div>';
  if(R2_GASTOS.length===1 && R2_GASTOS[0].origen==='diferencia'){
    h+='<div style="font-size:11px;color:#B45309;margin-top:6px">'
      +'Sin desglose por concepto: es la diferencia entre el total del documento y '
      +'la suma de las l\u00edneas. Para verlos separados hay que sincronizar '
      +'<b>gastos_documento</b>.</div>';
  }
  return h;
}

// Cuatro datos del formato no estan en el documento (a quien se factura, la
// condicion de pago y los gastos), asi que se piden antes en vez de dejarlos
// en blanco o inventarlos.
/* ── Que columnas salen ───────────────────────────────────────────────────
   Las quince del formato, cada una con su casilla. Las que no se marcan no
   se escriben y las demas se corren a la izquierda: no queda hueco.

   Las cuatro primeras -cajas, peso, pie cubico y referencia- van siempre.
   Sin referencia el Excel no sirve para nada, y las otras tres son el motivo
   de que este formato exista.
   ──────────────────────────────────────────────────────────────────────── */
var R2_COLS_FIJAS = [0, 1, 2, 3];      // CAJAS · PESO · PIE CUB · REFERENCIA

// Las etiquetas del modal van siempre en español: el idioma se elige mas
// abajo, en el propio modal, y aqui todavia no se sabe. El Excel si sale en
// el idioma elegido.
function r2ColsHTML(){
  var enc = r2t('cols', 'es');
  return enc.map(function(t, i){
    var fija = R2_COLS_FIJAS.indexOf(i) >= 0;
    return '<label style="display:flex;align-items:center;gap:6px;font-size:12.5px;'
      + (fija ? 'opacity:.55;' : 'cursor:pointer;') + '">'
      + '<input type="checkbox" class="r2-col" data-i="' + i + '" checked'
      + (fija ? ' disabled' : '') + '> ' + r2Esc(t) + '</label>';
  }).join('');
}

// Los indices de las columnas que hay que escribir, en orden.
function r2ColsElegidas(){
  var marcadas = document.querySelectorAll('.r2-col');
  if(!marcadas.length) return null;        // sin modal: todas
  var out = [];
  Array.prototype.forEach.call(marcadas, function(c){
    if(c.checked || c.disabled) out.push(parseInt(c.getAttribute('data-i'), 10));
  });
  return out.sort(function(a,b){ return a-b; });
}

async function r2Liran(){
  if(!r2Listo()) return;
  var d=await r2Datos();
  var cli=d.cliente||{};

  // El subtotal hace falta para poder deducir los gastos si no hay desglose.
  var sub=d.lineas.reduce(function(a,l){ return a+r2Num(l.total); },0);
  await r2CargarGastos(sub);

  var prev=document.getElementById('r2-liran-modal'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='r2-liran-modal';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13800;'
    +'display:flex;align-items:center;justify-content:center;padding:18px';

  var inp='width:100%;padding:8px 10px;border:1px solid var(--border,#d1d5db);'
    +'border-radius:8px;font-size:13px;font-family:inherit;box-sizing:border-box';
  var lab='display:block;font-size:11px;color:var(--text3,#888);text-transform:uppercase;'
    +'letter-spacing:.04em;font-weight:700;margin-bottom:3px';

  ov.innerHTML='<div style="background:var(--card,#fff);border-radius:14px;padding:20px;'
    +'max-width:560px;width:100%;max-height:90vh;overflow-y:auto">'
    +'<div style="font-size:15px;font-weight:700;margin-bottom:3px">Factura formato LIRAN</div>'
    +'<div style="font-size:12px;color:var(--text3,#888);margin-bottom:14px">'
      +(rptTipo==='factura'?'Factura':'Pedido')+' #'+r2Esc(String(rptDoc.docnum||''))
      +' \u00b7 '+d.lineas.length+' l\u00edneas</div>'

    +'<div style="margin-bottom:14px"><span style="'+lab+'">Idioma del reporte</span>'
      +'<div style="display:flex;gap:8px">'
      +'<label style="flex:1;cursor:pointer;border:1px solid var(--border,#d1d5db);'
        +'border-radius:8px;padding:8px 12px;font-size:13px;display:flex;gap:7px;align-items:center">'
        +'<input type="radio" name="r2-idi" value="es"> Espa\u00f1ol</label>'
      +'<label style="flex:1;cursor:pointer;border:1px solid var(--border,#d1d5db);'
        +'border-radius:8px;padding:8px 12px;font-size:13px;display:flex;gap:7px;align-items:center">'
        +'<input type="radio" name="r2-idi" value="en" checked> English</label>'
      +'</div></div>'

    +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px">'
      +'<div style="grid-column:span 2"><label style="'+lab+'">Sold to</label>'
        +'<input id="r2-soldto" style="'+inp+'" value="'+r2Esc(rptDoc.cardname||cli.cardname||'')+'"></div>'
      +'<div><label style="'+lab+'">Vendedor</label>'
        +'<input id="r2-vend" style="'+inp+'" value="'+r2Esc(rptDoc.nombrevendedor||cli.nombrevendedor||'')+'"></div>'
      +'<div><label style="'+lab+'">Fecha</label>'
        +'<input id="r2-fecha" style="'+inp+'" value="'+r2Esc(r2Fecha(rptDoc.docdate))+'"></div>'
      +'<div style="grid-column:span 2"><label style="'+lab+'">Condici\u00f3n de pago</label>'
        +'<input id="r2-terms" style="'+inp+'" value="'+r2Esc(cli.condicionpago||'')+'" '
        +'placeholder="60 DIAS FECHA BL"></div>'
    +'</div>'

    +'<div style="margin-top:14px"><span style="'+lab+'">Gastos adicionales del documento</span>'
      +'<div id="r2-gastos">'+r2GastosHTML()+'</div></div>'

    +'<div style="margin-top:14px"><span style="'+lab+'">Columnas del Excel</span>'
      +'<div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(132px,1fr));'
      +'gap:4px 10px;margin-top:5px">'+r2ColsHTML()+'</div></div>'

    +'<label style="display:flex;align-items:center;gap:8px;font-size:12.5px;margin-top:12px;'
      +'cursor:pointer"><input type="checkbox" id="r2-conFoto" checked> Incrustar las fotos '
      +'<span style="color:var(--text3,#888)">(tarda m\u00e1s)</span></label>'
    +'<div id="r2-liran-msg" style="font-size:12px;color:var(--text3,#888);margin-top:10px;'
      +'min-height:16px"></div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px;margin-top:6px">'
      +'<button class="btn" onclick="document.getElementById(\'r2-liran-modal\').remove()">Cancelar</button>'
      +'<button class="btn btn-p" id="r2-liran-btn" onclick="r2LiranGenerar()">Generar Excel</button>'
    +'</div></div>';
  document.body.appendChild(ov);
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
}

async function r2LiranGenerar(){
  var v=function(id){ var e=document.getElementById(id); return e?e.value:''; };
  var msg=document.getElementById('r2-liran-msg');
  var btn=document.getElementById('r2-liran-btn');
  var aviso=function(t){ if(msg) msg.textContent=t; };
  if(btn){ btn.disabled=true; btn.textContent='Generando\u2026'; }

  var idi='en';
  var r=document.querySelector('input[name="r2-idi"]:checked');
  if(r) idi=r.value;

  try{
    var ExcelJS=await _ensureExcelJS();
    var d=await r2Datos();
    var L=d.lineas;

    var conFoto=(document.getElementById('r2-conFoto')||{}).checked;
    var imgs={};
    if(conFoto){
      aviso('Descargando fotos\u2026');
      imgs=await r2Fotos(L, function(h,t){ aviso('Fotos '+h+'/'+t+'\u2026'); });
    }
    aviso('Armando la hoja\u2026');

    var wb=new ExcelJS.Workbook();
    // Sin cuadricula: la hoja sale limpia, como una factura impresa, y solo
    // se ven las lineas que dibujamos nosotros en la cabecera.
    var ws=wb.addWorksheet('Hoja1', {views:[{showGridLines:false}]});

    // Membrete: el logo va en las filas 1-8, como en el archivo original.
    var logo=r2Logo();
    if(logo){
      var idl=wb.addImage({base64:logo.b64, extension:logo.ext});
      ws.addImage(idl,{ tl:{col:0.15, row:0.3}, ext:{width:150,height:112} });
      ws.getCell('C2').value='KENNEDY CENTER CORP.';
      ws.getCell('C2').font={bold:true,size:16};
      ws.getCell('C3').value='ZONA LIBRE DE COLON  \u00b7  REP. DE PANAMA';
      ws.getCell('C3').font={size:10,color:{argb:'FF666666'}};
    } else {
      ws.getCell('A2').value='KENNEDY CENTER CORP.';
      ws.getCell('A2').font={bold:true,size:16};
      ws.getCell('A3').value='ZONA LIBRE DE COLON  \u00b7  REP. DE PANAMA';
      ws.getCell('A3').font={size:10,color:{argb:'FF666666'}};
    }
    for(var rr=1;rr<=8;rr++) ws.getRow(rr).height=14;

    var esFac=(rptTipo==='factura');
    ws.getCell('A9').value=r2t('soldto',idi)+': '+(v('r2-soldto')||'');
    ws.getCell('A9').font={bold:true};
    ws.getCell('E9').value=(esFac?r2t('invoice',idi):r2t('order',idi))+': '+(rptDoc.docnum||'');
    ws.getCell('E9').font={bold:true};
    ws.getCell('E10').value=r2t('vend',idi)+': '+(v('r2-vend')||'');
    ws.getCell('E11').value=r2t('fecha',idi)+': '+(v('r2-fecha')||'');
    ws.getCell('E12').value=r2t('terms',idi)+': '+(v('r2-terms')||'');

    // Las columnas que marco el usuario. `sel` guarda los indices ORIGINALES
    // para poder sacar el valor de cada linea; la posicion en la hoja es el
    // orden dentro de `sel`, asi no quedan huecos.
    var enc=r2t('cols',idi);
    var sel=r2ColsElegidas() || enc.map(function(_,i){ return i; });

    // Los anchos de las columnas que quedan, en su nueva posicion.
    var anchos=[10.3,12.6,10.1,26.1,53,6.7,7.3,15.7,17,19.6,24,23.9,14,12,15];
    sel.forEach(function(oi,pos){ ws.getColumn(pos+1).width=anchos[oi]||12; });

    sel.forEach(function(oi,pos){
      var t=enc[oi];
      var c=ws.getCell(13,pos+1);
      c.value=t; c.font={bold:true};
      c.fill={type:'pattern',pattern:'solid',fgColor:{argb:'FFE8F2EF'}};
      c.border={top:{style:'thin'},bottom:{style:'thin'},
                left:{style:'thin'},right:{style:'thin'}};
      c.alignment={vertical:'middle',wrapText:true};
    });

    var fila=14, ctnTot=0, sub=0;
    L.forEach(function(l){
      ctnTot+=l.ctn; sub+=r2Num(l.total);
      var vals=[
        l.ctn||null,
        l.peso ? Math.round(l.peso*l.qty*100)/100 : null,   // peso TOTAL de la linea
        l.volumen || null,                                   // pie cubico por pieza
        l.itemcode,
        (idi==='en' ? (l.desc_en||l.desc_es) : (l.desc_es||l.desc_en)),
        l.qty, l.unidad, l.precio, r2Num(l.total),
        l.barcode ? (isNaN(+l.barcode)?l.barcode:Number(l.barcode)) : '',
        l.marca, l.composicion,
        r2Pais(l.origen, idi),                               // CN -> CHINA / CHINA
        '',                                                  // la foto va encima
        l.color
      ];
      sel.forEach(function(oi,pos){
        var x=vals[oi];
        var c=ws.getCell(fila,pos+1);
        c.value=(x===null?'':x);
        c.alignment={vertical:'middle', wrapText:(oi===4||oi===11)};
        // Peso y pie cubico: dos decimales a secas.
        if(oi===1||oi===2) c.numFmt='0.00';
        // Precio y total: formato CONTABILIDAD en USD, que es el que alinea
        // el simbolo a la izquierda y los decimales en columna. Es lo que da
        // el aspecto de factura.
        if(oi===7||oi===8) c.numFmt='_("USD"* #,##0.00_);_("USD"* \\(#,##0.00\\);_("USD"* "-"??_);_(@_)';
      });
      // La foto va sobre la columna FOTO, este donde este tras quitar otras.
      var colFoto = sel.indexOf(13);
      var im=r2ImgDe(imgs,l);
      if(colFoto >= 0 && im && im.b64){
        ws.getRow(fila).height=42;
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id,{ tl:{col:colFoto+0.15, row:(fila-1)+0.12},
                         ext:{width:54,height:54}, editAs:'oneCell' });
      }
      fila++;
    });

    // Pie: cajas totales, subtotal, los gastos que se hayan puesto, y total.
    var pie=fila+1;
    // CAJAS y PESO son fijas, asi que siguen en A y B.
    ws.getCell('A'+pie).value=r2t('tctn',idi); ws.getCell('A'+pie).font={bold:true};
    ws.getCell('B'+pie).value=ctnTot;          ws.getCell('B'+pie).font={bold:true};

    // Los gastos vienen del documento; aqui solo se listan.
    var gastos=R2_GASTOS.filter(function(g){ return r2Num(g.v)!==0; });
    var partidas=[[r2t('subtotal',idi), sub]];
    var tot=sub;
    gastos.forEach(function(g){
      var val=r2Num(g.v);
      var nom=String(g.n).trim().toUpperCase();
      // El renglon deducido se traduce; los de SAP salen con su nombre real.
      if(g.origen==='diferencia' && idi==='en') nom='ADDITIONAL EXPENSES';
      partidas.push([nom+':', val]);
      tot+=val;
    });
    partidas.push([r2t('total',idi)+':', tot]);
    if(partidas[0][0].slice(-1)!==':') partidas[0][0]+=':';

    // Los totales van bajo PRECIO y TOTAL, esten donde esten tras ocultar
    // columnas. Antes iban clavados en H e I y se descolocaban.
    var colPre = sel.indexOf(7), colTot = sel.indexOf(8);
    if(colTot < 0) colTot = sel.length - 1;        // sin TOTAL, a la ultima
    if(colPre < 0) colPre = Math.max(0, colTot - 1);

    partidas.forEach(function(pp,i){
      var rw=pie+i;
      var a=ws.getCell(rw, colPre+1), b=ws.getCell(rw, colTot+1);
      a.value=pp[0]; a.font={bold:true}; a.alignment={horizontal:'right'};
      b.value=Math.round(pp[1]*100)/100;
      // El mismo formato USD de las lineas: si no, el total se ve distinto
      // del resto de la columna.
      b.numFmt='_("USD"* #,##0.00_);_("USD"* \\(#,##0.00\\);_("USD"* "-"??_);_(@_)';
      b.font={bold:(i===partidas.length-1)};
    });

    var buf=await wb.xlsx.writeBuffer();
    var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    var a=document.createElement('a');
    a.href=URL.createObjectURL(blob);
    a.download='LIRAN-'+(esFac?'INVOICE':'ORDER')+'-'+(rptDoc.docnum||'')+'.xlsx';
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);

    var m=document.getElementById('r2-liran-modal'); if(m) m.remove();
  }catch(e){
    aviso('No se pudo generar: '+(e&&e.message?e.message:e));
    if(btn){ btn.disabled=false; btn.textContent='Generar Excel'; }
  }
}

// El boton del liquid puede seguir llamando al nombre viejo.
function r2Aid(){ return r2Liran(); }
function r2AidGenerar(){ return r2LiranGenerar(); }


/* ══════════════════════════════════════════════════════════════════════════
   2) FICHA TECNICA DE ALFOMBRAS
   ══════════════════════════════════════════════════════════════════════════ */

// Que se considera alfombra: por el nombre o porque el articulo trae alguno
// de los campos tecnicos propios de una alfombra.
function r2EsAlfombra(l){
  var t=((l.desc_es||'')+' '+(l.desc_en||'')).toLowerCase();
  if(/alfombra|tapete|carpet|rug|gramp|grama/.test(t)) return true;
  var a=l.alf||{};
  return !!(a.pelo||a.respaldo||a.tecnica||a.espPelo||a.pesoPelo||a.gramaje);
}

// Pregunta el idioma y luego genera.
async function r2Alfombras(){
  if(!r2Listo()) return;
  var prev=document.getElementById('r2-alf-modal'); if(prev) prev.remove();
  var ov=document.createElement('div');
  ov.id='r2-alf-modal';
  ov.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:13800;'
    +'display:flex;align-items:center;justify-content:center;padding:18px';
  ov.innerHTML='<div style="background:var(--card,#fff);border-radius:14px;padding:20px;'
    +'max-width:400px;width:100%">'
    +'<div style="font-size:15px;font-weight:700;margin-bottom:3px">Ficha t\u00e9cnica de alfombras</div>'
    +'<div style="font-size:12px;color:var(--text3,#888);margin-bottom:14px">'
      +(rptTipo==='factura'?'Factura':'Pedido')+' #'+r2Esc(String(rptDoc.docnum||''))+'</div>'
    +'<span style="display:block;font-size:11px;color:var(--text3,#888);text-transform:uppercase;'
      +'letter-spacing:.04em;font-weight:700;margin-bottom:6px">Idioma del reporte</span>'
    +'<div style="display:flex;gap:8px">'
      +'<label style="flex:1;cursor:pointer;border:1px solid var(--border,#d1d5db);border-radius:8px;'
        +'padding:8px 12px;font-size:13px;display:flex;gap:7px;align-items:center">'
        +'<input type="radio" name="r2-alf-idi" value="es" checked> Espa\u00f1ol</label>'
      +'<label style="flex:1;cursor:pointer;border:1px solid var(--border,#d1d5db);border-radius:8px;'
        +'padding:8px 12px;font-size:13px;display:flex;gap:7px;align-items:center">'
        +'<input type="radio" name="r2-alf-idi" value="en"> English</label>'
    +'</div>'
    +'<div style="display:flex;justify-content:flex-end;gap:8px;margin-top:16px">'
      +'<button class="btn" onclick="document.getElementById(\'r2-alf-modal\').remove()">Cancelar</button>'
      +'<button class="btn btn-p" onclick="r2AlfGenerar()">Generar Excel</button>'
    +'</div></div>';
  document.body.appendChild(ov);
  ov.addEventListener('click', function(e){ if(e.target===ov) ov.remove(); });
}

async function r2AlfGenerar(){
  var idi='es';
  var r=document.querySelector('input[name="r2-alf-idi"]:checked');
  if(r) idi=r.value;
  var m=document.getElementById('r2-alf-modal'); if(m) m.remove();
  var inf=document.getElementById('rpt-info');
  var btn=document.getElementById('rpt-btn-alf');
  var prev=btn?btn.innerHTML:null;
  if(btn){ btn.disabled=true; btn.textContent='Generando\u2026'; }
  var aviso=function(t){ if(inf) inf.textContent=t; };

  try{
    var ExcelJS=await _ensureExcelJS();
    var d=await r2Datos();

    var L=d.lineas.filter(r2EsAlfombra);
    var filtrado=true;
    if(!L.length){
      // Ninguna linea parece alfombra: mejor sacar todas que un archivo vacio.
      L=d.lineas; filtrado=false;
    }

    aviso('Descargando fotos\u2026');
    var imgs=await r2Fotos(L, function(h,t){ aviso('Fotos '+h+'/'+t+'\u2026'); });
    aviso('Armando la hoja\u2026');

    var wb=new ExcelJS.Workbook();
    var ws=wb.addWorksheet('Ficha tecnica');

    var EN=(idi==='en');
    var cols=[
      {t:EN?'REFERENCE':'REFERENCIA', w:22, v:function(l){ return l.itemcode; }},
      {t:EN?'DESCRIPTION':'DESCRIPCION', w:38,
       v:function(l){ return EN?(l.desc_en||l.desc_es):(l.desc_es||l.desc_en); }},
      {t:EN?'BARCODE':'CODIGO DE BARRAS', w:20, v:function(l){ return l.barcode; }},
      {t:EN?'PILE COMPOSITION':'COMPOSICION DE PELO', w:24, v:function(l){ return l.alf.pelo; }},
      {t:EN?'BACKING COMPOSITION':'COMPOSICION DE RESPALDO', w:34, v:function(l){ return l.alf.respaldo; }},
      {t:EN?'MANUFACTURING TECHNIQUE':'TECNICA DE FABRICACION', w:22, v:function(l){ return l.alf.tecnica; }},
      {t:EN?'USE INTENSITY':'INTENSIDAD DE USO', w:18, v:function(l){ return l.alf.uso; }},
      {t:EN?'PILE THICKNESS':'ESPESOR DE PELO', w:16, v:function(l){ return l.alf.espPelo; }},
      {t:EN?'TOTAL THICKNESS':'ESPESOR TOTAL', w:15, v:function(l){ return l.alf.espTotal; }},
      {t:EN?'PILE WEIGHT':'PESO DE PELO', w:15, v:function(l){ return l.alf.pesoPelo; }},
      {t:EN?'SIZE IN CM':'MEDIDA EN CM', w:15, v:function(l){ return l.alf.medida; }},
      {t:EN?'WEAVE DENOMINATION':'DENOMINACION DEL TEJIDO', w:24, v:function(l){ return l.alf.tejido; }},
      {t:EN?'COLOR FINISHES':'ACABADOS POR COLOR', w:24, v:function(l){ return l.alf.acabadoCol; }},
      {t:EN?'OTHER FINISHES':'OTROS ACABADOS', w:18, v:function(l){ return l.alf.otros; }},
      {t:EN?'WEIGHT (GSM)':'GRAMAJE', w:14, v:function(l){ return l.alf.gramaje; }},
      {t:EN?'ORIGIN':'ORIGEN', w:16, v:function(l){ return r2Pais(l.origen, idi); }},
      {t:EN?'PHOTO':'FOTO', w:11, v:function(l){ return ''; }},
      {t:'COLOR', w:16, v:function(l){ return l.color; }}
    ];
    cols.forEach(function(c,i){ ws.getColumn(i+1).width=c.w; });

    ws.mergeCells(1,1,1,cols.length);
    var t1=ws.getCell('A1');
    t1.value=EN?'Rug technical sheet with photos':'Ficha t\u00e9cnica de alfombras con fotos';
    t1.font={bold:true,size:14};

    ws.getCell('A2').value=EN?'Execution Time:':'Fecha de emisi\u00f3n:';
    ws.getCell('B2').value=r2FechaHora();
    ws.getCell('A3').value=EN?(rptTipo==='factura'?'Invoice #':'Order #')
                                    :(rptTipo==='factura'?'Factura #':'Pedido #');
    ws.getCell('B3').value=rptDoc.docnum||'';
    ws.getCell('A4').value=EN?'Customer':'Cliente';
    ws.getCell('B4').value=(rptDoc.cardcode||'')+' - '+(rptDoc.cardname||'');
    ['A2','A3','A4'].forEach(function(k){ ws.getCell(k).font={bold:true,size:10}; });

    if(!filtrado){
      ws.getCell('A5').value='Ninguna l\u00ednea se reconoci\u00f3 como alfombra: '
        +'se incluyen todos los art\u00edculos del documento.';
      ws.getCell('A5').font={size:9,italic:true,color:{argb:'FFB45309'}};
    }

    var HDR=6;
    cols.forEach(function(c,i){
      var cel=ws.getCell(HDR,i+1);
      cel.value=c.t;
      cel.font={bold:true,size:9};
      cel.fill={type:'pattern',pattern:'solid',fgColor:{argb:'FFE8F2EF'}};
      cel.alignment={vertical:'middle',horizontal:'center',wrapText:true};
      cel.border={top:{style:'thin'},bottom:{style:'thin'},
                  left:{style:'thin'},right:{style:'thin'}};
    });
    ws.getRow(HDR).height=32;
    ws.views=[{state:'frozen', ySplit:HDR}];

    var fotoIdx=16;   // columna FOTO, base 0
    L.forEach(function(l,ri){
      var r=HDR+1+ri;
      cols.forEach(function(c,i){
        var cel=ws.getCell(r,i+1);
        cel.value=c.v(l)||'';
        cel.alignment={vertical:'middle',wrapText:(i===1||i===4)};
        cel.font={size:9};
        cel.border={top:{style:'hair'},bottom:{style:'hair'},
                    left:{style:'hair'},right:{style:'hair'}};
      });
      var im=r2ImgDe(imgs,l);
      if(im && im.b64){
        ws.getRow(r).height=46;
        var id=wb.addImage({base64:im.b64, extension:im.ext});
        ws.addImage(id,{ tl:{col:fotoIdx+0.12, row:(r-1)+0.1},
                         ext:{width:58,height:58}, editAs:'oneCell' });
      } else {
        ws.getRow(r).height=22;
        // Sin foto se deja el nombre del archivo, como el reporte de SAP.
        ws.getCell(r,fotoIdx+1).value=l.foto_url
          ? String(l.foto_url).split('/').pop() : '';
      }
    });

    ws.autoFilter={from:{row:HDR,column:1}, to:{row:HDR+L.length, column:cols.length}};

    var buf=await wb.xlsx.writeBuffer();
    var blob=new Blob([buf],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    var a=document.createElement('a');
    a.href=URL.createObjectURL(blob);
    a.download=(EN?'rug-tech-sheet-':'ficha-alfombras-')+(rptTipo==='factura'?'fac':'ped')+'-'+(rptDoc.docnum||'')+'.xlsx';
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);

    var vacias=r2Vacias(L);
    var txt=L.length+' art\u00edculo(s) en la ficha t\u00e9cnica.'
      +(filtrado?'':' Ninguno se reconoci\u00f3 como alfombra, se incluyeron todos.');
    if(vacias.length){
      // Sin esto, una columna en blanco parece un fallo del reporte y en
      // realidad es que el campo no llego de SAP con ese nombre.
      txt+=' Sin datos en: '+vacias.join(', ')+'. Escribe r2Claves() en la '
        +'consola (F12) para ver con qu\u00e9 nombre llegan.';
      try{
        console.log('%c COLUMNAS SIN DATOS ','background:#B45309;color:#fff;font-weight:700',
          vacias.join(', '));
        var todas={};
        L.forEach(function(l){ Object.keys(l._carac||{}).forEach(function(k){ todas[k]=1; }); });
        console.log('Nombres que SI llegan:', Object.keys(todas).sort().join(' | '));
      }catch(e){}
    }
    aviso(txt);
  }catch(e){
    alert('No se pudo generar la ficha: '+(e&&e.message?e.message:e));
    aviso('');
  }finally{
    if(btn){ btn.disabled=false; btn.innerHTML=prev; }
  }
}


/* ══════════════════════════════════════════════════════════════════════════
   Habilitar los botones junto a los de PDF y Excel
   ---------------------------------------------------------------------------
   rptToggleBtns solo conoce los dos botones originales. En vez de tocar esa
   funcion se envuelve: asi los nuevos botones se activan y desactivan a la vez
   que los otros y kennedy-2.js queda intacto.
   ══════════════════════════════════════════════════════════════════════════ */
(function(){
  if(typeof rptToggleBtns!=='function' || window._r2Envuelto) return;
  window._r2Envuelto=true;
  var orig=rptToggleBtns;
  rptToggleBtns=function(on){
    try{ orig(on); }catch(e){}
    ['rpt-btn-aid','rpt-btn-alf'].forEach(function(id){
      var b=document.getElementById(id); if(b) b.disabled=!on;
    });
  };
})();
